/**
 * legal_content.js
 * Legal texts for Privacy Policy and Terms of Use.
 */

export const LEGAL_CONTENT = {
    privacy: {
        title: "Privacy Policy",
        lastUpdated: "January 30, 2026",
        content: `
            <h3>1. Data Collection</h3>
            <p>Madmoco DevTools is a client-side toolbox. Most tools process data entirely within your browser and do not send information to any server.</p>
            
            <h3>2. Analytics</h3>
            <p>If you consent, we use Google Analytics to collect anonymous usage data (e.g., which tools are most used). This helps us prioritize improvements. We anonymize your IP address.</p>
            
            <h3>3. Local Storage</h3>
            <p>We use browser local storage to save your preferences, such as your dark mode setting and cookie consent. This data stays on your device.</p>
            
            <h3>4. Third Parties</h3>
            <p>We do not sell, trade, or otherwise transfer your information to outside parties.</p>

            <h3>5. Contact</h3>
            <p>For any questions regarding your privacy, contact us at: <strong>info@devtools.madmoco.com</strong></p>
        `
    },
    cookies: {
        title: "Cookie Policy",
        lastUpdated: "January 30, 2026",
        content: `
            <h3>1. What are cookies?</h3>
            <p>Cookies are small text files stored on your device that help us provide a better experience.</p>
            
            <h3>2. Cookies We Use</h3>
            <ul>
                <li><strong>Strictly Necessary:</strong> We use local storage to remember your tool preferences and your cookie consent choice.</li>
                <li><strong>Analytics:</strong> With your permission, we use Google Analytics (_ga) to collect anonymous data about tool popularity and usage.</li>
            </ul>
            
            <h3>3. Managing Cookies</h3>
            <p>You can revoke your consent at any time by clearing your browser's local storage or using the settings in your browser.</p>
        `
    },
    terms: {
        title: "Terms of Use",
        lastUpdated: "January 30, 2026",
        content: `
            <h3>1. Use of License</h3>
            <p>Madmoco DevTools is provided "as is" for developers. You are free to use these tools for personal or commercial projects.</p>
            
            <h3>2. Disclaimer</h3>
            <p>The tools provided are for convenience. Madmoco is not responsible for any data loss or errors caused by the output of these tools (e.g., regex results or code generation).</p>
            
            <h3>3. Modifications</h3>
            <p>We reserve the right to modify or remove tools at any time to improve the toolbox experience.</p>
        `
    }
};
